module.exports = __webpack_public_path__ + "static/media/card5.3347ee1b.jpg";